// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__b-nXv","location":"Header_location__249Ai"};